import { sanitizeHtml } from "@/lib/sanitizeHtml";

function setSafeHtml(el, binding) {
  const element = el;
  element.innerHTML = sanitizeHtml(binding.value);
}

export default {
  bind: setSafeHtml,
  update: setSafeHtml
};
